import { postJson } from '../httpClient';

export const brevoAPI = {
  addContact: (params) => postJson('/api/brevo/add-contact', params),
};
